import { render, staticRenderFns } from "./resize.vue?vue&type=template&id=114a2f4c&scoped=true"
import script from "./resize.vue?vue&type=script&lang=js"
export * from "./resize.vue?vue&type=script&lang=js"
import style0 from "./resize.vue?vue&type=style&index=0&id=114a2f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114a2f4c",
  null
  
)

export default component.exports